var React = require('react');

function Members (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeWidth":"2.5","transform":"translate(2 2)"},[React.createElement("circle",{"cx":"6","cy":"3","r":"3","key":0}),React.createElement("path",{"d":"M12 13c0-3.513-2.686-6-6-6s-6 2.534-6 6c0 1.011 12 1.043 12 0z","key":1})]));
}

Members.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18"};

module.exports = Members;

Members.default = Members;
